import LebookLogo from '../assets/lebook-logo.webp';

type LogoMainProps = {
    className?: string;
};
export function LogoMain({ className }: LogoMainProps) {
    return (
        <img
            src={LebookLogo}
            alt="Lebook Logo"
            className={className}
            style={{ height: '22px' }}
        />
    );
}
